import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { PartKey } from '../../types';
import { PlannerEcsSystem } from './System';
export class OutlineSelectedFrameSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'OutlineSelectedFrameSystem', ComponentIds.SELECTED_COMPONENT_ID);
    }
    onAdd(entity) {
        if (entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
            const stackedFrameEntities = HierarchyUtils.descendants(entity).filter(child => child.hasComponent(ComponentIds.FRAME_COMPONENT_ID));
            const stackedFrames = stackedFrameEntities
                .flatMap(frame => {
                return frame.hasComponent(ComponentIds.ASSEMBLY_STRUCTURE_COMPONENT_ID)
                    ? this.coreApi.entities.findEntityWithPartKey(HierarchyUtils.children(frame), PartKey.FRAME)
                    : frame;
            })
                .filter((e) => !!e);
            stackedFrames.forEach(f => {
                const frameChildren = HierarchyUtils.descendants(f);
                [f, ...frameChildren].forEach(child => {
                    const model = child.getComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID)?.viewerObject;
                    if (model) {
                        // Remove outline from stacked frames and its children (doors, interiors ...)
                        model.setOutlined(false);
                        model.setBlockOutlined(true);
                    }
                });
            });
        }
    }
    onUpdate() { }
    onRemove(entity) {
        if (entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
            // Handle re-add of outline for selected stacked frames when unselecting parent frame
            const stackedSelectedFrameEntities = HierarchyUtils.descendants(entity).filter(child => child.hasComponent(ComponentIds.FRAME_COMPONENT_ID) &&
                child.hasComponent(ComponentIds.SELECTED_COMPONENT_ID));
            const stackedSelectedFrames = stackedSelectedFrameEntities
                .flatMap(frame => {
                return frame.hasComponent(ComponentIds.ASSEMBLY_STRUCTURE_COMPONENT_ID)
                    ? this.coreApi.entities.findEntityWithPartKey(HierarchyUtils.children(frame), PartKey.FRAME)
                    : frame;
            })
                .filter((e) => !!e);
            stackedSelectedFrames.forEach(f => {
                const frameChildren = HierarchyUtils.descendants(f);
                [f, ...frameChildren].forEach(child => {
                    const model = child.getComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID)?.viewerObject;
                    if (model) {
                        model.setOutlined(true);
                        model.setBlockOutlined(false);
                    }
                });
            });
        }
    }
}
//# sourceMappingURL=OutlineSelectedFrameSystem.js.map